import api from './index'
import { axios } from '@/utils/request'

export function getMenu(parameter) {
  return axios({
    url: api.BaseURL + api.Menu,
    method: 'GET',
    data: parameter
  })
}
